export function filterKeys(source, options) {
  const { allowlist, denylist } = options;
  return Object.keys(source).reduce((acc, key) => {
    let matches = true;
    if (allowlist?.length) {
      matches = matches && allowlist.some((pattern) => {
        if (typeof pattern === "string") {
          return key === pattern;
        }
        return key.match(pattern);
      });
    }
    if (denylist?.length) {
      matches = matches && !denylist.some((pattern) => {
        if (typeof pattern === "string") {
          return key === pattern;
        }
        return key.match(pattern);
      });
    }
    if (matches) {
      acc[key] = source[key];
    }
    return acc;
  }, {});
}
